import { styled, useTheme } from '@mui/material/styles';
import {
    Card,
    CardContent,
    Grid,
    Typography,
    useMediaQuery
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Color from '../../../layouts/Color';
import FontSize from '../../../layouts/FontSize';

const useStyles = makeStyles(function (theme) {
    return {
        cardContent: {
            padding: 10,
            '&:last-child': {
                paddingBottom: '8px',
            },
        }
        , logo: {
            [theme.breakpoints.down("sm")]: {
                height: 40
            },
        }
    }
});

const logoBank = { float: 'left', width: '60%' };
const mainText = { color: Color.Main, textAlign: 'center' };

const CardStyle = styled(Card)(({ theme }) => ({
    background: theme.palette.background.default,
    border: '1px solid hsla(240,7%,62%,1)',
    marginBottom: '2px',
    overflow: 'hidden',
    position: 'relative',
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: 336,
    maxHeight: 192,
    borderRadius: '12px',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: 155,
        height: 155,
        background: theme.palette.primary[200],
        borderRadius: '50%',
        top: '-105px',
        right: '-96px'
    },

}));

// ==============================|| Single Card ||============================== //

const ipsStyle = { paddingBottom: '10px' };
const textColor = { color: Color.Main };

const SingleCard = (props) => {
    const theme = useTheme();
    const classes = useStyles();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));

    const renderIPS = (ips) => {
        switch (ips) {
            case "VISA":
                return <img src={'./assets/images/card/visa.png'} height={matchDownXL ? '18px' : '30px'} alt="ips-logo" style={{ float: 'right', marginTop: `${matchDownXL ? '3px' : '5px'}`, width: '20%', height: 'auto' }} />
            case "MASTER":
                return <img src={'./assets/images/card/master.png'} height={matchDownXL ? '18px' : '30px'} alt="ips-logo" style={{ float: 'right', marginTop: `${matchDownXL ? '3px' : '5px'}`, width: '20%', height: 'auto' }} />
            case "NAPAS":
                return <img src={'../assets/images/card/napas.png'} height={matchDownXL ? '16px' : '30px'} alt="ips-logo" style={{ float: 'right', marginTop: `${matchDownXL ? '3px' : '5px'}`, width: '20%', height: 'auto' }} />;
            default:
                return;
        }
    }


    return props.contract !== null ? (
        <Grid>
            <CardStyle  >
                <CardContent className={classes.cardContent}>
                    <Grid container spacing={matchDownXL ? 0.5 : 1}>
                        <Grid item md={6} sm={6} xs={6} className={classes.logo}>
                            <img src={'./assets/images/card/bank-logo.png'}
                                height={matchDownXL ? '50' : '60'} alt="bank-logo" style={logoBank} />
                        </Grid>
                        <Grid item xs={6} sm={6} md={6} sx={{ textAlign: 'right', zIndex: 1 }}>
                            <Typography variant={matchDownXL ? 'body1' : 'body2'} sx={[textColor, { pt: 1 }]}> {props.contract.contractType}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> {(props.contract.contractNumber).slice(0, 4)} </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> {(props.contract.contractNumber).slice(4, 8).replace("__", "**")} </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> {(props.contract.contractNumber).slice(8, 12).replace("____", "****")} </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> {(props.contract.contractNumber).slice(12, 16)} </Typography>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            <Typography variant={matchDownXL ? 'body1' : 'body2'} sx={textColor}> {props.contract.embossingName}</Typography>
                        </Grid>
                        <Grid item md={6} sm={6} xs={6}>
                            <Typography
                                fontSize={matchDownSM ? FontSize.ExtraTiny : FontSize.VeryTiny}
                                marginTop={matchDownSM ? '0.2px' : '1px'}
                                sx={textColor}> Valid From: {props.contract.issuedDate}</Typography>
                        </Grid>
                        <Grid item md={6} sm={6} xs={6}>
                            <Typography
                                fontSize={matchDownSM ? FontSize.ExtraTiny : FontSize.VeryTiny}
                                marginTop={matchDownSM ? '0.2px' : '1px'}
                                sx={textColor}> Good Thur: {props.contract.expiredDate}</Typography>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12} sx={ipsStyle}>
                            {renderIPS(props.contract.product.brandName)}
                        </Grid>
                    </Grid>

                </CardContent>
            </CardStyle>
        </Grid>
    ) : (
        <Grid>
            <CardStyle  >
                <CardContent className={classes.cardContent}>
                    <Grid container spacing={matchDownXL ? 0.5 : 1}>
                        <Grid item md={12} sm={12} xs={12} className={classes.logo}>
                            <img src={'./assets/images/card/bank-logo.png'} height={matchDownXL ? '50' : '60'} alt="bank-logo" style={logoBank} />
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant={matchDownXL ? 'h5' : 'h4'} sx={mainText}> </Typography>
                        </Grid>
                        <Grid item md={6} sm={6} xs={6}>
                            <Typography variant={matchDownXL ? 'h6' : 'h5'} sx={textColor}> </Typography>
                        </Grid>
                        <Grid item md={6} sm={6} xs={6}>
                            <Typography
                                fontSize={matchDownSM ? FontSize.ExtraTiny : FontSize.VeryTiny}
                                marginTop={matchDownSM ? '0.2px' : '1px'}
                                sx={textColor}> Valid From: </Typography>
                            <Typography
                                fontSize={matchDownSM ? FontSize.ExtraTiny : FontSize.VeryTiny}
                                marginTop={matchDownSM ? '0.2px' : '1px'}
                                sx={textColor}> Good Thur: </Typography>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12} sx={ipsStyle}>
                            {renderIPS(props.ips)}
                        </Grid>
                    </Grid>

                </CardContent>
            </CardStyle>
        </Grid>
    );
};

export default SingleCard;
